// Глобальный пульт управления интерфейсом
export const APP_INTERFACE_SETTINGS = {
  // 1. ВИБРООТКЛИК (Уже работает в Summary и CartMobileModal)
  vibrationEnabled: true,

  // 2. ЗВУКОВОЙ ОТКЛИК ИНТЕРФЕЙСА
  //
  // Функция:
  // управляет короткими звуками нажатия в интерфейсе.
  //
  // Важно:
  // - enabled выключает ВСЕ звуки интерфейса сразу
  // - defaultEnabled отвечает за обычные клики по всему сайту
  // - categoryEnabled отвечает только за карусель категорий / подкатегорий
  // - addToCartEnabled отвечает только за финальное добавление товара в корзину
  //
  // Главная идея:
  // все частоты, громкость и длительности хранятся здесь,
  // чтобы не искать настройки звука внутри app-tap-sound.ts.
  tapSound: {
    enabled: true,

    // Обычные кнопки / ссылки по всему сайту.
    // Можно выключить, если общий звук по сайту начнёт раздражать.
    defaultEnabled: true,

    // Категории / подкатегории.
    // Оставляем включённым, потому что здесь звук помогает навигации.
    categoryEnabled: true,

    // Финальная кнопка добавления товара в корзину.
    // Отдельный, более яркий звук типа coin / sparkle.
    addToCartEnabled: true,

    // Резерв для будущих отдельных действий.
    removeEnabled: true,
    successEnabled: true,
    closeEnabled: true,

    // Общие fallback-параметры.
    // Используются, если у конкретного профиля не задано своё значение.
    volume: 0.020,
    durationMs: 155,
    frequencies: [390, 420, 440, 460],

    // ПРОФИЛИ ЗВУКОВ
    // Здесь находятся все реальные настройки тональности.
    // Менять частоты лучше здесь, а не в файле проигрывателя.
    profiles: {
      // Обычный короткий звук интерфейса.
      default: {
        volume: 0.020,
        durationMs: 155,
        frequencies: [390, 420, 440, 460],
        oscillatorType: "sine",
        endFrequencyMultiplier: 1,
      },

      // Звук выбора категории / подкатегории.
      category: {
        volume: 0.020,
        durationMs: 155,
        frequencies: [390, 420, 440, 460],
        oscillatorType: "sine",
        endFrequencyMultiplier: 2,
      },

      // Звук реального добавления товара в корзину.
      // Это короткий эффект coin / sparkle: два слоя звука.
      addToCart: {
        volume: 0.090,
        steps: [
          {
            frequency: 340,
            durationMs: 295,
            volumeMultiplier: 1.15,
            endFrequencyMultiplier: 2.42,
            oscillatorType: "triangle",
          },
          {
            frequency: 520,
            delayMs: 240,
            durationMs: 275,
            volumeMultiplier: 0.42,
            endFrequencyMultiplier: 2.18,
            oscillatorType: "sine",
          },
        ],
      },

      // Резерв: звук удаления / минус-действия.
      remove: {
        volume: 0.020,
        steps: [
          {
            frequency: 520,
            durationMs: 65,
            volumeMultiplier: 0.85,
            endFrequencyMultiplier: 0.62,
            oscillatorType: "sine",
          },
        ],
      },

      // Резерв: звук успешного завершения действия.
      success: {
        volume: 0.020,
        steps: [
          {
            frequency: 660,
            durationMs: 45,
            volumeMultiplier: 1,
            endFrequencyMultiplier: 1.08,
            oscillatorType: "sine",
          },
          {
            frequency: 880,
            delayMs: 45,
            durationMs: 70,
            volumeMultiplier: 0.95,
            endFrequencyMultiplier: 1.04,
            oscillatorType: "sine",
          },
        ],
      },

      // Резерв: звук закрытия панели / окна.
      close: {
        volume: 0.020,
        steps: [
          {
            frequency: 620,
            durationMs: 55,
            volumeMultiplier: 0.8,
            endFrequencyMultiplier: 0.75,
            oscillatorType: "sine",
          },
        ],
      },
    },
  },

  // 3. АНИМАЦИИ
  animations: {
    useCartZigZag: true,    // РАБОТАЕТ: Управляет краем бумаги в корзине

    // --- БУТАФОРИЯ (Внедряем в следующих шагах) ---
    useCoinFlipPrice: false, // [В РАЗРАБОТКЕ]: Переворот цены при изменении
    useSidePanels: false,    // [В РАЗРАБОТКЕ]: Выезд боковых панелей
    globalDuration: 300,     // [В РАЗРАБОТКЕ]: Общая скорость анимаций
  },

  // 4. ВИЗУАЛЬНЫЕ ЭФФЕКТЫ
  visuals: {
    // --- БУТАФОРИЯ (Внедряем в следующих шагах) ---
    useBlurEffects: false,   // [В РАЗРАБОТКЕ]: Размытие заднего плана
    transparentUI: false,    // [В РАЗРАБОТКЕ]: Прозрачность элементов интерфейса
  },
}
